import Client from './Client';

export default class StudentClient {
  constructor() {
    this.client = Client;
  }

  /**
   * 获取学员
   */
  async getList(data) {
    const res = await this.client.post('/api/user/pageStudent', data);
    return res;
  }

  /**
   * info
   * @param
   * id
   */
  async getInfo(id) {
    const res = await this.client.post(`/api/user/getStudent?userId=${id}`);
    return res;
  }

  /**
   * 一键完成学习进度条
   * @param
   * id
   */
  async completeLiveWatch(data) {
    const res = await this.client.post('/api/live/watch/summary/completeLiveWatch', data);
    return res;
  }
}